import { useState } from "react";
import { ThemeProvider, useTheme } from "./components/Theme";
import { getPerfil, NAV_ITEMS } from "./components/Permissoes";
import { useNotificacoes, NotificacaoToast } from "./components/Notificacoes";
import Login    from "./pages/Login";
import Suspenso from "./pages/Suspenso";

// Importar páginas do CRM
import Leads         from "./pages/Leads";
import Kanban        from "./pages/Kanban";
import Negociacoes   from "./pages/Negociacoes";
import Projetos      from "./pages/Projetos";
import Financeiro    from "./pages/Financeiro";
import Calendario    from "./pages/Calendario";
import Dashboard     from "./pages/Dashboard";
import PainelVendas  from "./pages/PainelVendas";
import Clientes      from "./pages/Clientes";
import Usuarios      from "./pages/Usuarios";
import Configuracoes from "./pages/Configuracoes";

const ORANGE = "#FF6B2B";

function AcessoNegado() {
  const { theme } = useTheme();
  return (
    <div style={{ padding:80, textAlign:"center", background:theme.bg, minHeight:"60vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
      <div style={{ fontSize:56, marginBottom:20 }}>🔒</div>
      <h3 style={{ margin:"0 0 10px", color:theme.text, fontSize:22, fontWeight:700 }}>Acesso Restrito</h3>
      <p style={{ margin:0, fontSize:15, color:theme.textMuted }}>Você não tem permissão para esta página.</p>
    </div>
  );
}

function AppInner() {
  const { theme, toggleTheme } = useTheme();
  const [user, setUser]   = useState(() => { try { return JSON.parse(localStorage.getItem("oo_user")); } catch { return null; } });
  const [page, setPage]   = useState("leads");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [leadParaAbrir, setLeadParaAbrir] = useState(null);
  const { notifs, adicionar, limpar } = useNotificacoes();

  // Verificar se está na página de suspenso
  if (window.location.pathname === "/suspenso") return <Suspenso />;

  const handleLogin = (u) => { setUser(u); setPage("leads"); };
  const handleLogout = () => { localStorage.removeItem("oo_token"); localStorage.removeItem("oo_user"); setUser(null); };
  const handleUserUpdate = (u) => { setUser(u); localStorage.setItem("oo_user", JSON.stringify(u)); };

  if (!user) return <Login onLogin={handleLogin} />;

  const perfil = getPerfil(user.role);
  const navVisivel = NAV_ITEMS.filter(n => perfil.paginas.includes(n.id));
  const temPermissao = (id) => perfil.paginas.includes(id);
  const paginaAtual = NAV_ITEMS.find(n => n.id === page);

  // Detectar nome da empresa pelo subdomínio
  const subdomain = window.location.hostname.split(".")[0];
  const nomeEmpresa = subdomain !== "localhost" && subdomain !== "www"
    ? subdomain.charAt(0).toUpperCase() + subdomain.slice(1)
    : "Optimus One";

  return (
    <div style={{ minHeight:"100vh", background:theme.bg, fontFamily:"'Inter',-apple-system,sans-serif", color:theme.text, display:"flex" }}>

      {/* SIDEBAR */}
      <div style={{ width:sidebarOpen?224:66, minWidth:sidebarOpen?224:66, background:theme.bgSecond, borderRight:`1px solid ${theme.border}`, display:"flex", flexDirection:"column", position:"fixed", top:0, left:0, bottom:0, zIndex:50, overflow:"hidden", transition:"width .25s, min-width .25s" }}>

        {/* Logo */}
        <div style={{ padding:"16px 14px", borderBottom:`1px solid ${theme.border}`, display:"flex", alignItems:"center", gap:10, minHeight:64 }}>
          <div style={{ width:34, height:34, borderRadius:10, background:`linear-gradient(135deg,${ORANGE},#FF9A5C)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, flexShrink:0 }}>⚡</div>
          {sidebarOpen && <div style={{ overflow:"hidden" }}>
            <div style={{ fontWeight:800, fontSize:13, color:theme.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{nomeEmpresa}</div>
            <div style={{ fontSize:10, color:theme.textMuted }}>Optimus One</div>
          </div>}
        </div>

        {/* Nav */}
        <div style={{ flex:1, padding:"10px 8px", overflowY:"auto" }}>
          {navVisivel.map(n => {
            const active = page === n.id;
            return (
              <button key={n.id} onClick={()=>setPage(n.id)} style={{ width:"100%", display:"flex", alignItems:"center", gap:10, padding:sidebarOpen?"9px 12px":"9px 0", justifyContent:sidebarOpen?"flex-start":"center", borderRadius:10, marginBottom:2, cursor:"pointer", border:"none", background:active?ORANGE+"1A":"transparent", color:active?ORANGE:theme.textMuted, fontWeight:active?600:400, fontSize:13.5, transition:"all .15s", fontFamily:"'Inter',sans-serif" }}
                onMouseEnter={e=>{ if(!active){e.currentTarget.style.background=theme.bgInput;e.currentTarget.style.color=theme.text;} }}
                onMouseLeave={e=>{ e.currentTarget.style.background=active?ORANGE+"1A":"transparent";e.currentTarget.style.color=active?ORANGE:theme.textMuted; }}>
                <span style={{ fontSize:17, flexShrink:0 }}>{n.emoji}</span>
                {sidebarOpen && <span style={{ whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{n.label}</span>}
                {active && sidebarOpen && <div style={{ width:5, height:5, borderRadius:"50%", background:ORANGE, marginLeft:"auto", flexShrink:0 }}/>}
              </button>
            );
          })}
        </div>

        {/* Perfil + controles */}
        <div style={{ padding:"12px 8px", borderTop:`1px solid ${theme.border}` }}>
          {sidebarOpen && (
            <div style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 12px", borderRadius:10, background:theme.bgInput, marginBottom:10 }}>
              <div style={{ width:32, height:32, borderRadius:10, background:perfil.color+"25", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, flexShrink:0 }}>{perfil.emoji}</div>
              <div style={{ overflow:"hidden", flex:1 }}>
                <div style={{ fontSize:13, fontWeight:600, color:theme.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{user.nome?.split(" ")[0]}</div>
                <div style={{ fontSize:11, color:perfil.color, fontWeight:500 }}>{perfil.label}</div>
              </div>
            </div>
          )}
          <div style={{ display:"flex", gap:6 }}>
            <button onClick={toggleTheme} style={{ flex:1, padding:"8px 0", borderRadius:8, border:`1px solid ${theme.border}`, background:"transparent", color:theme.textMuted, cursor:"pointer", fontSize:15 }}>{theme.name==="dark"?"☀️":"🌙"}</button>
            <button onClick={()=>setSidebarOpen(o=>!o)} style={{ flex:1, padding:"8px 0", borderRadius:8, border:`1px solid ${theme.border}`, background:"transparent", color:theme.textMuted, cursor:"pointer", fontSize:13 }}>{sidebarOpen?"◀":"▶"}</button>
            <button onClick={handleLogout} title="Sair" style={{ flex:1, padding:"8px 0", borderRadius:8, border:`1px solid ${theme.border}`, background:"transparent", color:theme.textMuted, cursor:"pointer", fontSize:14 }}>⏻</button>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div style={{ flex:1, marginLeft:sidebarOpen?224:66, transition:"margin-left .25s", minHeight:"100vh", display:"flex", flexDirection:"column" }}>

        {/* Topbar */}
        <div style={{ height:60, background:theme.bgSecond, borderBottom:`1px solid ${theme.border}`, display:"flex", alignItems:"center", padding:"0 28px", position:"sticky", top:0, zIndex:40 }}>
          <div style={{ fontSize:19, fontWeight:700, color:theme.text }}>{paginaAtual?.emoji} {paginaAtual?.label}</div>
          <div style={{ marginLeft:"auto", fontSize:13, color:theme.textMuted }}>
            Olá, <span style={{ color:theme.text, fontWeight:600 }}>{user.nome?.split(" ")[0]}</span> {perfil.emoji}
          </div>
        </div>

        {/* Páginas */}
        <div style={{ flex:1, overflow:"auto" }}>
          {page==="leads"        && (temPermissao("leads")        ? <Leads        currentUser={user}/> : <AcessoNegado/>)}
          {page==="kanban"       && (temPermissao("kanban")       ? <Kanban        onStageChange={adicionar} leadIdParaAbrir={leadParaAbrir} currentUser={user}/> : <AcessoNegado/>)}
          {page==="negociacoes"  && (temPermissao("negociacoes")  ? <Negociacoes   currentUser={user}/> : <AcessoNegado/>)}
          {page==="projetos"     && (temPermissao("projetos")     ? <Projetos      currentUser={user}/> : <AcessoNegado/>)}
          {page==="financeiro"   && (temPermissao("financeiro")   ? <Financeiro    currentUser={user}/> : <AcessoNegado/>)}
          {page==="calendario"   && (temPermissao("calendario")   ? <Calendario    onAbrirLead={(id)=>{ setLeadParaAbrir(id); setPage("kanban"); }}/> : <AcessoNegado/>)}
          {page==="dashboard"    && (temPermissao("dashboard")    ? <Dashboard/> : <AcessoNegado/>)}
          {page==="vendas"       && (temPermissao("vendas")       ? <PainelVendas  currentUser={user}/> : <AcessoNegado/>)}
          {page==="clientes"     && (temPermissao("clientes")     ? <Clientes      currentUser={user}/> : <AcessoNegado/>)}
          {page==="usuarios"     && (temPermissao("usuarios")     ? <Usuarios      currentUser={user}/> : <AcessoNegado/>)}
          {page==="configuracoes"&& (temPermissao("configuracoes")? <Configuracoes user={user} onUserUpdate={handleUserUpdate} currentUser={user}/> : <AcessoNegado/>)}
        </div>
      </div>

      <NotificacaoToast notifs={notifs} limpar={limpar}/>
    </div>
  );
}

export default function App() {
  return <ThemeProvider><AppInner/></ThemeProvider>;
}
